import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReAuth } from './base-query'
import type { OkResponse } from './types/common'
import type {
	CreateDealMessageBody,
	DealMessage,
	ListDealMessagesParams,
	ListDealMessagesResponse,
	MarkDealMessageReadBody,
} from './types/deal'

export const dealMessagesApi = createApi({
	reducerPath: 'dealMessagesApi',
	baseQuery: baseQueryWithReAuth,
	tagTypes: ['DealMessage'],
	endpoints: (builder) => ({
		listDealMessages: builder.query<ListDealMessagesResponse, ListDealMessagesParams>({
			query: ({ dealId, ...params }) => ({
				url: `/crm/deals/${dealId}/messages`,
				params,
			}),
			providesTags: (_r, _e, { dealId }) => [{ type: 'DealMessage', id: dealId }],
		}),

		sendDealMessage: builder.mutation<DealMessage | null, CreateDealMessageBody>({
			query: ({ dealId, ...body }) => ({
				url: `/crm/deals/${dealId}/messages`,
				method: 'POST',
				body,
			}),
			invalidatesTags: (_r, _e, { dealId }) => [{ type: 'DealMessage', id: dealId }],
		}),

		markDealMessageRead: builder.mutation<OkResponse, MarkDealMessageReadBody>({
			query: ({ messageId, dealId }) => ({
				url: `/crm/messages/${messageId}/read`,
				method: 'PATCH',
				body: { dealId },
			}),
			invalidatesTags: (_r, _e, { dealId }) => [{ type: 'DealMessage', id: dealId }],
		}),
	}),
})

export const {
	useListDealMessagesQuery,
	useSendDealMessageMutation,
	useMarkDealMessageReadMutation,
} = dealMessagesApi
